import { AVERAGE } from 'settings/constants';

export const PERCENTAGE_MULTIPLIER = 100;
export const MONTH_DATE_FORMAT = 'MMMM YYYY';
export const VALUE_KEY_PREFIX = 'value_';
export const FUNNEL_PREFIX = 'funnel_';
export const AVERAGE_LABEL = AVERAGE;
export const AVG_LABEL_TEXT = 'Avg';

export const CHART_DATA_POINT_DEFAULTS = {
  BAR_FILL: 1,
  FUNNEL_FILL: 0,
  HEIGHT: 0,
  BAR_LABEL: null,
  FUNNEL_TOOLTIP: null,
} as const;
